import React from 'react'

class Disclaimer extends React.Component {
  render() {
    const {
      futureRepayment,
    } = this.props

    return(
      <div style={ styles.disclaimer }>
        <span>Based on today’s interest rates, your repayment will indicatively increase to </span>
        <span>{ futureRepayment }</span>
        <span>, at the end of the Interest only period.</span>
      </div>
    )
  }
}

const styles = {
  disclaimer: {
    fontSize: '85%',
    fontStyle: 'italic',
  }
}

export default Disclaimer
